<template>
  <div class="tab-content">
    <b-row class="mb-3">
      <b-col cols="12">
        <EstadoCarga :filas-con-error="filasConError" :es-inicial="totalFilas === 0" />
      </b-col>
    </b-row>

    <EstadisticasCarga
      :total-filas="totalFilas"
      :filas-actualizadas="filasActualizadas"
      :filas-con-error="filasConError"
    />

    <b-row class="mt-4">
      <b-col cols="12">
        <TablaErrores :errores="errores" />
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col cols="12" class="text-right">
        <b-button variant="primary" class="btn-guardar mr-3 rounded-pill" @click="$emit('finalizar')">
          Finalizar
        </b-button>
        <b-button variant="secondary" class="btn-cancelar rounded-pill" @click="$emit('descargarErrores')" :disabled="errores.length === 0">
          Descargar errores
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import EstadoCarga from './EstadoCarga.vue';
import EstadisticasCarga from './EstadisticasCarga.vue';
import TablaErrores from './TablaErrores.vue';

export default {
  name: 'TabResultados',
  components: {
    EstadoCarga,
    EstadisticasCarga,
    TablaErrores
  },
  props: {
    totalFilas: {
      type: Number,
      default: 0
    },
    filasActualizadas: {
      type: Number,
      default: 0
    },
    filasConError: {
      type: Number,
      default: 0
    },
    errores: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.btn-guardar {
  background-color: #0046A2;
  border-color: #0046A2;
  padding: 8px 20px;
}

.btn-guardar:hover {
  background-color: #003880;
  border-color: #003880;
}

.btn-cancelar {
  background-color: #6c757d;
  border-color: #6c757d;
  padding: 8px 20px;
}

.btn-cancelar:hover {
  background-color: #5a6268;
  border-color: #545b62;
}
</style>